import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Key_getInstance30q5r2nw695ls as Key_getInstance } from './CustomScalarAdapters.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { nullable1in0t8o94jx9t as nullable } from './Adapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from './json/MapJsonWriter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Variables1mnjguxfc49u as Variables } from './Executable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function falseVariables(_this__u8e3s4, customScalarAdapters) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = variables(_this__u8e3s4, customScalarAdapters, true).a47_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = LinkedHashMap().gc();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = tmp0.q3().u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    if (equals(element.s3(), false)) {
      destination.c5(element.r3(), element.s3());
    }
  }
  return destination.a5();
}
function parseData(_this__u8e3s4, jsonReader, customScalarAdapters, falseVariables, deferredFragmentIds, errors) {
  customScalarAdapters = customScalarAdapters === VOID ? Key_getInstance().x45_1 : customScalarAdapters;
  falseVariables = falseVariables === VOID ? null : falseVariables;
  deferredFragmentIds = deferredFragmentIds === VOID ? null : deferredFragmentIds;
  errors = errors === VOID ? null : errors;
  var customScalarAdapters1 = customScalarAdapters.s43().f46(falseVariables).g46(deferredFragmentIds).h44(errors).n37();
  return nullable(_this__u8e3s4.b47()).b40(jsonReader, customScalarAdapters1);
}
function variables(_this__u8e3s4, customScalarAdapters, withDefaultValues) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (MapJsonWriter())();
  this_0.c41();
  _this__u8e3s4.c47(this_0, customScalarAdapters, withDefaultValues);
  this_0.d41();
  var tmp = this_0.f41();
  var valueMap = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
  return new (Variables())(valueMap);
}
//region block: exports
export {
  falseVariables as falseVariables32gd1w4dsf9iv,
  parseData as parseData1xjh6qzzvft3n,
};
//endregion

//# sourceMappingURL=Executables.mjs.map
